var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-container"},[(!_vm.showTime)?_c('div',{staticClass:"message",on:{"click":_vm.sendSMS}},[_vm._v("\n        获取短信验证码\n    ")]):_c('div',{staticClass:"recapture"},[_c('i',[_vm._v(_vm._s(_vm.time))]),_c('em',[_vm._v("秒后可重新获取")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }